import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  group: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  label: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
  selected: {
    fontWeight: 600,
  },
}));

const VersionChipGroup = ({ label, items, selectedIds, onToggle, disabled, getLabel }) => {
  const classes = useStyles();

  return (
    <Box>
      {label ? (
        <Typography className={classes.label} component="div">
          {label}
        </Typography>
      ) : null}
      <Box className={classes.group}>
        {(items || []).map(item => {
          const selected = selectedIds.includes(item.id);
          return (
            <Chip
              key={item.id}
              label={getLabel(item)}
              color={selected ? 'primary' : 'default'}
              variant={selected ? 'default' : 'outlined'}
              className={selected ? classes.selected : undefined}
              onClick={() => {
                if (!disabled) {
                  onToggle(item.id);
                }
              }}
              disabled={disabled}
              size="small"
            />
          );
        })}
      </Box>
    </Box>
  );
};

VersionChipGroup.propTypes = {
  label: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  getLabel: PropTypes.func.isRequired,
};

VersionChipGroup.defaultProps = {
  label: '',
  disabled: false,
};

export default VersionChipGroup;
